import axiosInstance from '@/Utils/axiosInstance';
const language = localStorage.getItem('language');
export const TicketsService = {
  // Patient CRUD Operations
  getTickets: async (page = 1, limit = 10, filters) => {
    try {
      const { status, dateRange, startDate, endDate, searchTerm } = filters;

      const params = {
        page,
        limit,
        ...(status && { status }),
        ...(dateRange && { dateRange }),
        ...(startDate && { startDate: new Date(startDate).toISOString() }),
        ...(endDate && { endDate: new Date(endDate).toISOString() }),
        ...(searchTerm && { search: searchTerm }),
      };
      const response = await axiosInstance.get(`/doctors-app-ticketing`, {
        params,
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error('Failed to get patients');
    }
  },
  getTicketById: async (id) => {
    try {
      const response = await axiosInstance.get(`/doctors-app-ticketing/${id}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to get patient by id');
    }
  },
  deleteTicket: async (id) => {
    try {
      const response = await axiosInstance.delete(`/doctors-app-ticketing/${id}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to delete ticket');
    }
  },
  updateTicket: async (data, id) => {
    const response = await axiosInstance.put(`/doctors-app-ticketing/${id}`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return response.data;
  },
  addComment: async (data, id) => {
    const response = await axiosInstance.post(`/doctors-app-ticketing/comment/${id}`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return response.data;
  },
  fetchUserRole: async () => {
    try {
      const response = await axiosInstance.get('/doctorsappuser/role', {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch user role');
    }
  },
  addAttachment: async (data) => {
    const response = await axiosInstance.post(`/medicalrecords/insert_medical_record`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
  },
  getAttachments: async (ticketId) => {
    try {
      const response = await axiosInstance.get(`/doctors-app-ticketing/attachments/${ticketId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch user role');
    }
  },
  deleteAttachment: async (attachmentId) => {
    try {
      const response = await axiosInstance.delete(`/medicalrecords/${attachmentId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to delete attachment');
    }
  },
  getTicketsByPatientId: async (userId) => {
    try {
      const response = await axiosInstance.get(`/doctors-app-ticketing/patient/${userId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to get tickets by user id');
    }
  },
  getAppointmentsByPatientId: async (userId) => {
    try {
      const response = await axiosInstance.get(
        `/doctors-app-ticketing/patient/${userId}/appointments`,
        {
          headers: {
            Authorization: localStorage.getItem('token'),
            lang: language,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to get patient appointments');
    }
  },
  getHospitalsAndClinics: async () => {
    try {
      const response = await axiosInstance.get('/medicalrecords/get_clinics_hospitals', {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch hospitals and clinics');
    }
  },
  getTicketsCount: async () => {
    try {
      const response = await axiosInstance.get('/doctors-app-ticketing/all-tickets-count', {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data.data;
    } catch (error) {
      throw new Error('Failed to fetch tickets count');
    }
  },

  getExpertNotesByTicket: async (ticketId) => {
    try {
      const response = await axiosInstance.get(`/expert-notes/ticket?ticket_id=${ticketId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch expert notes');
    }
  },

  getFileUrl: async (fileName, user_id) => {
    try {
      const response = await axiosInstance.get(`/expert-notes/file/${fileName}/${user_id}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch expert notes');
    }
  },

  deleteExpertNote: async (noteId) => {
    try {
      const response = await axiosInstance.delete(`/expert-notes/${noteId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to delete expert notes');
    }
  },

  addExpertNoteToTicket: async (data) => {
    const formData = new FormData();
    formData.append('note', data.note);
    data.files.forEach((file) => formData.append('files', file));
    if (data.ticket_id) {
      formData.append('ticket_id', data.ticket_id);
    }
    formData.append('doctor_id', data.doctor_id);
    formData.append('external_user_id', data.external_user_id);
    const response = await axiosInstance.post(`/expert-notes`, formData, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return response;
  },

  addExpertNoteToPatient: async (data) => {
    try {
      const formData = new FormData();
      formData.append('note', data.note);
      data.files.forEach((file) => formData.append('files', file));
      formData.append('doctor_id', data.doctor_id);
      formData.append('external_user_id', data.external_user_id);
      const response = await axiosInstance.post(`/expert-notes`, formData, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: language,
        },
      });
      return response;
    } catch (error) {
      throw new Error(`Failed to add expert note: ${error}`);
    }
  },

  updateTicketStatus: async (data, id) => {
    const response = await axiosInstance.patch(`/doctors-app-ticketing/update-status/${id}`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
        lang: language,
      },
    });
    return response;
  },
};
